export default "__VITE_ASSET__D6c4ZxaY__"